import { render, staticRenderFns } from "./setting-styleEditor.vue?vue&type=template&id=2adf5f30&scoped=true&"
import script from "./setting-styleEditor.vue?vue&type=script&lang=js&"
export * from "./setting-styleEditor.vue?vue&type=script&lang=js&"
import style0 from "./setting-styleEditor.vue?vue&type=style&index=0&id=2adf5f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adf5f30",
  null
  
)

export default component.exports